import React from 'react'
import { CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { YearlyOverviewTitle } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { companyViewChart } from '../../../../Data/DashboardsData/DefaultData'

export default function YearlyOverview() {
    return (
        <Col xl={5} md={6} className="box-col-6">
            <div className="card">
                <DropdownWithHeader headerClass='pb-0' heading={YearlyOverviewTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="p-0">
                    <div id="company-viewchart">
                        <ReactApexChart type='area' options={companyViewChart} series={companyViewChart.series} height={380} />
                    </div>
                </CardBody>
            </div>
        </Col>
    )
}
